import React from 'react';
import { moduleHint } from '../utils/rbacLabels';
import { IITH } from '@/pages/landing/iithBrand';

/** One module block with select-all and permission checkboxes. */
export default function PermissionsModuleBlock({
  module, items, checked, onToggle, onToggleModule,
}) {
  const enabled = items.filter((p) => checked.has(p.code)).length;
  const allOn = enabled === items.length && items.length > 0;

  return (
    <section className="rounded-xl border bg-white overflow-hidden shadow-sm" data-testid={`perm-module-${module}`}>
      <header className="px-4 py-3 border-b bg-zinc-50/70 flex flex-wrap items-start justify-between gap-2">
        <div className="min-w-0">
          <p className="text-sm font-semibold text-zinc-900">{module}</p>
          <p className="text-[11px] text-zinc-500 mt-0.5">{moduleHint(module)}</p>
        </div>
        <div className="flex items-center gap-3">
          <span className="text-[11px] tabular-nums text-zinc-500">
            {enabled}/{items.length}
          </span>
          <button
            type="button"
            onClick={() => onToggleModule(items, !allOn)}
            className="text-[11px] font-semibold"
            style={{ color: IITH.saffron }}
          >
            {allOn ? 'Clear module' : 'Select module'}
          </button>
        </div>
      </header>
      <div className="p-3 grid sm:grid-cols-2 gap-2">
        {items.map((p) => {
          const on = checked.has(p.code);
          return (
            <label
              key={p.code}
              className={`flex items-start gap-2.5 rounded-lg px-3 py-2.5 text-sm cursor-pointer border transition ${
                on ? 'border-[#F15A22]/35 bg-[#FFF7F3]' : 'border-zinc-100 hover:bg-zinc-50'
              }`}
            >
              <input
                type="checkbox"
                className="mt-0.5 h-4 w-4 rounded border-zinc-300"
                checked={on}
                onChange={() => onToggle(p.code)}
                data-testid={`perm-check-${p.code}`}
              />
              <span className="min-w-0">
                <span className="font-medium text-zinc-800 block leading-snug">{p.name}</span>
                <span className="text-[11px] text-zinc-500 font-mono">{p.code}</span>
              </span>
            </label>
          );
        })}
      </div>
    </section>
  );
}
